<template>
  <div class="container">
    <div class="topic_line">
      <input
        type="text"
        v-model="info.Title"
        placeholder="话题名称"
        maxlength="15"
        @blur.prevent="changeCount()"
      />
      <div>{{ info.Title.length }}/15字</div>
    </div>
    <div class="topic_line">
      <textarea
        auto-height
        v-model="info.Intro"
        placeholder="话题介绍"
        maxlength="80"
        @blur.prevent="changeCount()"
      ></textarea>
      <div>{{ info.Intro.length }}/80字</div>
    </div>

    <div class="senior-box" @click.stop="seniorSwitch">
      <div
        class="iconfont"
        :class="seniorOpen ? 'icon-arrow-up' : 'icon-arrow-down'"
      ></div>
      <div>高级选项</div>
    </div>
    <div class="topic_head" v-if="seniorOpen">
      <div class="title">话题头部背景</div>
      <div class="radio-box">
        <div :class="type == 0 ? 'active' : ''" @click.stop="radioSelect(0)">
          <div
            class="iconfont "
            :class="type == 0 ? 'icon-radio-on' : 'icon-radio'"
          ></div>
          推荐
        </div>
        <div :class="type == 1 ? 'active' : ''" @click.stop="radioSelect(1)">
          <div
            class="iconfont"
            :class="type == 0 ? 'icon-radio' : 'icon-radio-on'"
          ></div>
          自定义
        </div>
      </div>

      <!-- 推荐 -->
      <div class="img-box" v-if="type == 0">
        <div v-for="(item, index) in imgList" :key="index">
          <div
            :class="index == imgIdx ? 'active' : ''"
            @click.stop="choiceClick(index)"
          >
            <img
              v-if="index == imgIdx"
              src="../../../static/images/icon/select-btm.png"
              class="rbIcon"
            />
            <img :src="item" class="backdrop" />
          </div>
        </div>
      </div>
      <!-- 自定义 -->
      <div class="custom-box" v-else>
        <div class="addImg" v-if="!customBg">
          <van-uploader class="customImg" :after-read="afterRead" multiple />
        </div>
        <van-image fit="cover" :src="customBg" class="customImg" v-else />
        <div>建议尺寸：600x400像素</div>
      </div>
    </div>

    <button :disabled="disabled" class="submitBtn" @click.stop="submitClick">
      创建
    </button>
  </div>
</template>
<script>
import { uploadImg, createPostTopic } from "@/api/publish";
import { topicBgImgList } from "@/api/topic";
import { Icon, Uploader, Toast ,Image} from "vant";
import FooterTab from "@/components/FooterTab";
export default {
  name: "publishTopic",
  components: {
    FooterTab,
    "van-uploader": Uploader,
    "van-icon": Icon,
    "van-image":Image,
    Toast,
  },
  data() {
    return {
      seniorOpen: false,
      type: 0, //0推荐 1自定义
      disabled: true,

      info: {
        Title: "",
        Intro: "",
      },

      pageIndex: 1,
      imgList: [],
      imgIdx: 0,
      customBg: "",
    };
  },
  methods: {
    //失去焦点
    changeCount() {
      this.disabled = false;
    },
    //高级打开状态切换
    seniorSwitch() {
      this.seniorOpen = !this.seniorOpen;
    },
    //单选
    radioSelect(n) {
      this.type = n;
      this.checkData();
    },

    // 获取话题背景图列表
    getTopicBgImgList() {
      topicBgImgList().then((res) => {
        this.imgList = res.Data;
      });
    },

    //上下切换
    switchClick() {
      this.pageIndex =
        this.pageIndex * 4 >= this.imgList.length ? 1 : this.pageIndex + 1;
    },

    //推荐背景选择
    choiceClick(index) {
      this.imgIdx = this.imgIdx == index ? -1 : index;
      this.checkData();
    },

    //上传图片
    afterRead(file) {
      const param = new FormData();
      param.append("file", file.file);
      uploadImg(param).then((res) => {
        this.customBg = res.Data;
        this.checkData();
      });
    },

    //创建话题
    submitClick() {
      var that = this;
      var data = {
        TopicName: that.info.Title,
        TopicDesc: that.info.Intro,
        BackImage: that.customBg ? that.customBg : that.imgList[that.imgIdx],
        CateId: that.$route.query.tcid ? that.$route.query.tcid : 0,
      };
      createPostTopic(data).then((res) => {
        Toast("创建成功");
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      });
    },

    //检测数据是否完整（创建按钮是否可点击）
    checkData() {
      if (this.info.Title != "" && this.info.Intro != "") {
        if (this.type == 0) {
          this.disabled = this.imgIdx == -1 ? true : false;
        } else {
          this.disabled = this.customBg == "" ? true : false;
        }
      } else {
        this.disabled = true;
      }
    },
  },
  created() {
    var that = this;
    //底部导航栏
    that.$store.commit("setFooterNav", "publish");
  },
  mounted() {
    this.getTopicBgImgList();
  },
};
</script>
<style scoped src="../../../static/css/publishTopic.css"></style>
